<template>
  <div class="toolbox-drawers">
    <div class="toolbox-drawers__drawer-rack">
      <component
        :is="drawer.icon"
        v-for="drawer in drawers"
        :key="drawer.id"
        class="toolbox-drawers__drawer"
        :class="{selected: selectedDrawer?.id === drawer.id, disabled: drawer.disabled}"
        @click="handleDrawerClick(drawer)"
      />
    </div>
    <div
      v-show="selectedDrawer"
      class="toolbox-drawers__opened-drawer"
    >
      <component
        :is="selectedDrawer?.drawerComponent"
        :tools="selectedDrawer?.tools"
      />
    </div>
  </div>
</template>

<script>

/**
 * @typedef {import('@/internal/store/toolbox').ToolboxDrawer} ToolboxDrawer
 */

export default {
  name: 'ToolboxDrawers',
  props: {
    drawers: {
      type: Array,
      default: () => [],
    },
    selectedDrawer: {
      type: Object,
      default: null,
    },
  },
  emits: ['selectedTool', 'setSelectedDrawer'],
  methods: {
    /** @param {ToolboxDrawer} clickedDrawer */
    async handleDrawerClick(clickedDrawer) {
      if (clickedDrawer.disabled) return;

      const oldDrawerId = this.selectedDrawer?.id;
      this.$emit('setSelectedDrawer', (oldDrawerId === clickedDrawer.id) ? null : clickedDrawer);
      // Wait for the drawer to open/close
      await this.$nextTick();
      // We either closed the drawer or we opened a new one
      if (!this.selectedDrawer || oldDrawerId !== this.selectedDrawer.id) {
        this.$emit('selectedTool', null);
      }

      if (this.selectedDrawer && this.selectedDrawer.tools.length === 1) {
        this.$emit('selectedTool', this.selectedDrawer.tools[0]);
      }
    },

    /**
     * Convenience method to close any open drawer.
     */
    closeOpenDrawer() {
      this.$emit('setSelectedDrawer', null);
      this.$emit('selectedTool', null);
    },
  },
};
</script>

<style lang="scss" scoped>
.toolbox-drawers {
  &__drawer-rack {
    background-color: #FFF;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 7px;
    border-radius: 5px;
  }

  &__drawer {
    height: 45px;
    width: 45px;
    padding: 8px;
    fill: main.$npGray;

    &:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    &:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }

    &:hover:not(.disabled) {
      background-color: main.$midGray;
      cursor: pointer;
    }
    &.selected, &.selected:hover {
      background-color: main.$npGray;
      fill: #FFF;
      :deep(.st0) {
        stroke: #FFF;
      }
    }
    &.disabled {
      fill: darkgray;
    }
  }

  &__opened-drawer {
    height: 100%;
    width: 100%;
    background-color: #FFF;
  }
}
</style>
